import { CustomTableColumn } from "./custom-table-column";

export class DynamicDetailsLinkTableColumn extends CustomTableColumn {

    idPath: string;
    typePath: string;

    constructor(name: string, label: string, path: string, idPath: string, typePath: string) {
        super(name, label, path);
        this.idPath = idPath;
        this.typePath = typePath;
    }
}
